export default __webpack_public_path__ + "static/PolitecnicoDiMilano-bb600e150a0b8f26b13fabd19b9fcfe2.svg";